import { filterProducts, productDetailBySlug, favProduct } from "@/api/productAPI";

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

export const getFilteredProducts = createAsyncThunk(
    'products/getFilteredProducts',
    async (reqObj) => {
        const reponse = await filterProducts(reqObj);
        return reponse;
    }
);

export const getProduct = createAsyncThunk("products/getProduct",
    async (slug) => {
        const reponse = await productDetailBySlug(slug);
        return reponse;
    }
)

export const favoriteProduct = createAsyncThunk("products/favoriteProduct", 
    async (product_id) => {
        const response = await favProduct(product_id);
        return response;
    }
)

const productSlice = createSlice({
    name: "products",
    initialState: { list: [], loading: false, error: null, productDetail: null, fav_product : null },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getFilteredProducts.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getFilteredProducts.fulfilled, (state, action) => {
                state.loading = false;
                state.list = action.payload
            })
            .addCase(getFilteredProducts.rejected, (state, action) => {
                state.loading = false;
                state.error = "Something Went Wrong!"
            })
            .addCase(getProduct.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getProduct.fulfilled, (state, action) => {
                state.loading = false;
                state.productDetail = action.payload
            })
            .addCase(getProduct.rejected, (state, action) => {
                state.loading = false;
                state.error = "Something Went Wrong!"
            })
            .addCase(favoriteProduct.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(favoriteProduct.fulfilled, (state, action) => {
                state.loading = false;
                state.fav_product = action.payload
            })
            .addCase(favoriteProduct.rejected, (state, action) => {
                state.loading = false;
                state.error = "Something Went Wrong!"
            });
    }
});

export const getProducts = (state) => state.products.list;

export default productSlice.reducer;